import { useLocation } from "react-router-dom";

/**
 * Returns the URL prefix of the layout currently rendering the calling page.
 *
 * Shared resource pages (Properties, Contracts, PropertyDetails, …) are
 * mounted under both `/dashboard/*` (admin) and `/portal/<role>/*` (portals).
 * Those pages historically hardcoded `/dashboard/...` paths inside their
 * `navigate(...)` and `<Link to=...>` calls, which forced portal users into
 * the admin layout whenever they clicked through a card.  Calling this hook
 * and prefixing routes with the returned base keeps users inside their own
 * URL space.
 *
 * Admin (`/dashboard/*`) callers get `/dashboard` back, so behavior is
 * unchanged for them.
 */
export function usePortalBase(): string {
  const { pathname } = useLocation();
  if (pathname.startsWith("/portal/employee")) return "/portal/employee";
  if (pathname.startsWith("/portal/owner")) return "/portal/owner";
  if (pathname.startsWith("/portal/tenant")) return "/portal/tenant";
  if (pathname.startsWith("/portal/provider")) return "/portal/provider";
  if (pathname.startsWith("/super-admin")) return "/super-admin";
  return "/dashboard";
}
